// extracted by mini-css-extract-plugin
module.exports = {"separatedByComma":"ManufacturerTab_separatedByComma__oWU6v","separatedBySlash":"ManufacturerTab_separatedBySlash__yIi9x","link":"ManufacturerTab_link__l55mh"};